import { createContext, useContext } from 'react'
import type { OperatorSession } from '../domain/session'

export interface AuthState {
  status: 'loading' | 'signed-out' | 'signed-in'
  session: OperatorSession | null
  error: string | null
  signIn: (identifier: string, password: string) => Promise<void>
  signOut: () => Promise<void>
  replaceTemporaryPassword: (currentPassword: string, newPassword: string) => Promise<void>
  refresh: () => Promise<void>
}

export const AuthContext = createContext<AuthState | null>(null)

export function useAuth(): AuthState {
  const value = useContext(AuthContext)
  if (!value) throw new Error('useAuth hors de AuthProvider')
  return value
}
